import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CallService } from 'src/app/core/services';

@Component({
  selector: 'app-track-nivedan-dialog',
  templateUrl: './track-nivedan-dialog.component.html',
  styleUrls: ['./track-nivedan-dialog.component.scss']
})
export class TrackNivedanDialogComponent {
  loader: boolean = false;
  toolTip: string = 'Click to copy'

  constructor(private dialogRef: MatDialogRef<TrackNivedanDialogComponent>,
    private _router: Router, private callerService: CallService,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { }

  closeDialog() {
    this.dialogRef.close(false);
    console.log('dialog closed');

  }


  onCreateNew() {
    this.callerService.openSlider(true)

    // this.loader = true;
    this.dialogRef.close(true);
    // setTimeout(() => {
    //   this.loader = false
    // }, 2000);
    // this._router.navigate(['admin/dashboard']);
  }

  onCreateExisting() {
    this.callerService.openSlider(false)
    this.dialogRef.close({
      call: 'existing',
      devoteeDetailsForm: this.data.devoteeDetailsForm,
      addressDetailsForm: this.data.addressDetailsForm,
      otherDetailsForm: this.data.otherDetailsForm,
      nibedonDetailsForm: this.data.nibedonDetailsForm,
    });

  }




}
